/**
 * sortByRank - Utilizes the rank object property to sort in ascending order.
 *
 * @param {Object} firstElement - First object to compare via rank property
 * @param {Object} secondElement - Second object to compare via rank property
 *
 * @return {Integer} - Returns the proper integer value to sort elements.
 */
export default function sortByRank(firstElement, secondElement) {
    const { rank: firstRank } = firstElement;
    const { rank: secondRank } = secondElement;
    return (firstRank === secondRank) ? 0 : (firstRank < secondRank) ? -1 : 1; // eslint-disable-line no-nested-ternary
}



// WEBPACK FOOTER //
// ./app/lib/util/sortByRank.js